import { initIndexDBSuccess } from "../store/spa-app-actions.js";
import { createLogger } from "../helper/logger.js";
import { pdStore } from "../store/mini-rx.store.js";
//#region src/db/indexDB.ts
var dbLogger = createLogger("PdIndexDB");
var USER_COLLECTION = "dcInternalUser";
var { indexedDB } = window;
var db;
var add = (table, el, ignoreDuplicates) => new Promise((resolve, reject) => {
	const request = db.transaction([table], "readwrite").objectStore(table).add(el);
	request.onsuccess = () => resolve(request.result);
	request.onerror = (event) => {
		const target = event.target;
		if (target.error?.name === "ConstraintError" && ignoreDuplicates) return resolve("duplicate");
		dbLogger.warn("Unable to add data!", event, el);
		return reject(target.error);
	};
});
var update = (table, el) => new Promise((resolve, reject) => {
	const request = db.transaction([table], "readwrite").objectStore(table).put(el);
	request.onsuccess = () => resolve(request.result);
	request.onerror = (event) => {
		const target = event.target;
		dbLogger.warn("Unable to put data!", event, el);
		return reject(target.error);
	};
});
var updateAll = (table, elArray) => new Promise((resolve, reject) => {
	const promises = [];
	elArray.forEach((el) => {
		promises.push(update(table, el));
	});
	return Promise.all(promises).then((resArr) => resolve(resArr)).catch((e) => reject(e));
});
var addAll = (table, elArray, ignoreDuplicates) => new Promise((resolve, reject) => {
	const promises = [];
	elArray.forEach((el) => {
		promises.push(add(table, el, ignoreDuplicates));
	});
	return Promise.all(promises).then((resArr) => resolve(resArr)).catch((e) => reject(e));
});
var deleteEl = (table, id) => new Promise((resolve, reject) => {
	const request = db.transaction([table], "readwrite").objectStore(table).delete(id);
	request.onsuccess = () => resolve(request.result);
	request.onerror = (e) => reject(e.target.error);
});
var deleteAllEl = (table, elIdArray) => new Promise((resolve, reject) => {
	const promises = [];
	elIdArray.forEach((elId) => {
		promises.push(deleteEl(table, elId));
	});
	return Promise.all(promises).then((resArr) => resolve(resArr)).catch((e) => reject(e));
});
var get = (table, id) => new Promise((resolve, reject) => {
	const request = db.transaction([table]).objectStore(table).get(id);
	request.onsuccess = () => resolve(request.result);
	request.onerror = (e) => reject(e.target.error);
});
var getAll = (table, index) => new Promise((resolve, reject) => {
	const request = index ? db.transaction([table], "readonly").objectStore(table).index(index).openCursor() : db.transaction([table], "readonly").objectStore(table).openCursor();
	const res = [];
	request.onsuccess = function(event) {
		const cursor = event.target.result;
		if (cursor) {
			res.push(cursor.value);
			cursor.continue();
		} else resolve(res);
	};
	request.onerror = (e) => reject(e.target.error);
});
var getAllIds = (table) => new Promise((resolve, reject) => {
	const request = db.transaction([table], "readonly").objectStore(table).openCursor();
	const res = [];
	request.onsuccess = function(event) {
		const cursor = event.target.result;
		if (cursor) {
			res.push(cursor.value.id);
			cursor.continue();
		} else resolve(res);
	};
	request.onerror = (e) => reject(e.target.error);
});
var deleteAll = (table) => new Promise((resolve, reject) => {
	const request = db.transaction([table], "readwrite").objectStore(table).clear();
	request.onsuccess = () => resolve(request.result);
	request.onerror = (e) => reject(e.target.error);
});
var removeDatabase = (dbName) => new Promise((resolve, reject) => {
	db.close();
	const request = indexedDB.deleteDatabase(dbName);
	request.onsuccess = () => resolve(request.result);
	request.onerror = (e) => reject(e.target.error);
});
/**
* Init indexDB for application.
*
* @param config - config for index db
*/
var initDB = (config) => {
	if (!indexedDB) window.alert("Your browser doesn't support a stable version of IndexedDB.");
	else {
		const { dbName, dbVersion, collections } = config;
		const request = indexedDB.open(dbName, dbVersion);
		request.onerror = (event) => {
			dbLogger.error("Error during init:", event);
		};
		request.onsuccess = () => {
			db = request.result;
			dbLogger.debug(`init success: ${db}`);
			pdStore().dispatch(initIndexDBSuccess());
		};
		request.onupgradeneeded = (event) => {
			dbLogger.info("Upgrade needed", event);
			db = event.target.result;
			switch (event.oldVersion) {
				case 0:
					db.createObjectStore(USER_COLLECTION, { keyPath: "id" });
					collections.forEach((c) => {
						db.createObjectStore(c.name, c.collectionConf);
					});
					break;
				default:
					dbLogger.info("Updating database structure for existing version");
					if (!db.objectStoreNames.contains("dcInternalUser")) db.createObjectStore(USER_COLLECTION, { keyPath: "id" });
					collections.forEach((c) => {
						if (!db.objectStoreNames.contains(c.name)) db.createObjectStore(c.name, c.collectionConf);
					});
			}
		};
	}
};
//#endregion
export { USER_COLLECTION, add, addAll, deleteAll, deleteAllEl, get, getAll, getAllIds, initDB, removeDatabase, update, updateAll };
